/* -------------------------------------------------
  Header Scroll Logic
------------------------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  const header = document.getElementById('header');
  const stickyBlock = document.querySelector('.sticky-block');

  if (!header || !stickyBlock) return;

  let lastScrollY = window.scrollY;
  let isHidden = false;

  // Tailwind transition
  stickyBlock.classList.add('sticky', 'transition-[top]', 'duration-300', 'ease-in-out');

  const setStickyOffset = (offset) => {
    stickyBlock.style.top = `${offset}px`;
  };

  const showHeader = () => {
    header.style.transform = 'translateY(0)';
    setStickyOffset(header.offsetHeight);
    stickyBlock.classList.add('header-visible');
    isHidden = false;
  };

  const hideHeader = () => {
    header.style.transform = 'translateY(-100%)';
    setStickyOffset(12);
    stickyBlock.classList.remove('header-visible');
    isHidden = true;
  };

  // 👉 On load: ALWAYS show header, just adjust sticky block
  header.style.transform = 'translateY(0)';
  setStickyOffset(header.offsetHeight);
  stickyBlock.classList.add('header-visible');

  // If already scrolled down, keep header visible but ensure correct spacing
  if (window.scrollY > 50) {
    setStickyOffset(header.offsetHeight);
  }

  window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;

    // Scroll down → hide header
    if (currentScrollY > lastScrollY && currentScrollY > 50) {
      if (!isHidden) hideHeader();
    }

    // Scroll up → show header
    if (currentScrollY < lastScrollY) {
      if (isHidden) showHeader();
    }

    lastScrollY = currentScrollY;
  });
});


/* -------------------------------------------------
  Product Card Hover
------------------------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  function initStickyHover(selector, activeClass = 'is-active') {
    const items = document.querySelectorAll(selector);

    let currentActive = null;

    items.forEach(item => {
      item.addEventListener('mouseenter', () => {

        // Remove from previous
        if (currentActive && currentActive !== item) {
          currentActive.classList.remove(activeClass);

          const prevVideo = currentActive.querySelector('video');
          if (prevVideo) {
            prevVideo.pause();
            prevVideo.currentTime = 0; // optional: reset
          }
        }

        // Add to current
        item.classList.add(activeClass);
        currentActive = item;

        // Play current video
        const video = item.querySelector('video');
        if (video) {
          video.play().catch(() => {}); // avoid autoplay errors
        }
      });
    });
  }

  initStickyHover('.product--card');
});



/* -------------------------------------------------
  Helpers
------------------------------------------------- */

// Visible Viewport Height
function getVisibleHeightInViewport(el) {
  if (!el) return 0;
  const rect = el.getBoundingClientRect();
  const vh = window.innerHeight || document.documentElement.clientHeight;
  const visible = Math.min(rect.bottom, vh) - Math.max(rect.top, 0);
  return Math.max(0, Math.ceil(visible));
}

// Drawer Spacer
function recalcDrawerSpacer() {
  const announcement = document.getElementById('announcement-bar');
  const header = document.getElementById('header');
  const annVisibleH = announcement ? getVisibleHeightInViewport(announcement) : 0;
  const headerH = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
  const total = annVisibleH + headerH;
  document.documentElement.style.setProperty('--drawerSpacer', `${total}px`);
}

// Promo Spacer
function recalcHeroSpacer() {
  const announcement = document.getElementById('announcement-bar');
  const promo = document.getElementById('promo-bar');
  const annVisibleH = getVisibleHeightInViewport(announcement);
  const proVisibleH = getVisibleHeightInViewport(promo);
  const total = annVisibleH + proVisibleH;
  if (document.getElementById('promo-bar')) {
    document.documentElement.style.setProperty('--heroSpacer', `${total}px`);
  } else {
     document.documentElement.style.setProperty('--heroSpacer', `0px`);
  }
}
document.addEventListener('DOMContentLoaded', () => {
  recalcHeroSpacer();
});

/* -------------------------------------------------
  CLOSE PROMO BANNER
------------------------------------------------- */
document.addEventListener("DOMContentLoaded", function() {

  // Set Variables
  const btn = document.getElementById('close-promo');
  const bar = document.getElementById('promo-bar');
  const hero = document.getElementById('hero');

  // Button Exists
  if (btn) {

    // Button Click
    btn.addEventListener('click', function() {

      // Remove Bar
      bar.remove();

      // Undo the spacer override so header-spacer padding applies again
      const spacerStyle = document.getElementById('promo-spacer-style');
      if (spacerStyle) spacerStyle.remove();

      // Calculate New Spacing
      const header = document.getElementById('header');
      const headerH = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
      let headerPaddingBottom = 0;
      if (header) {
        const styles = window.getComputedStyle(header);
        headerPaddingBottom = parseFloat(styles.paddingBottom) || 0;
      }
      const mt = headerH - headerPaddingBottom;

      // Hero Exists
      if (hero) {
        // Update Hero Spacing & Height
        hero.style.setProperty('padding-top', `${mt}px`);
        hero.style.setProperty('height', '100dvh');
      }

      // Fetch Cart
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          // Set Closed Attribute
          attributes: { promo_bar_closed: '1' }
        })
      })
      .then(response => {
        if (!response.ok) throw new Error('Network Error');
        return response.json();
      })
      .catch(err => {
        console.error('Promo Attribute Failed', err);
        btn.disabled = false;
      });
    });
  }
});


/* -------------------------------------------------
  FLOATING BUTTON - hide for 3 days after click
------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  const floatingBtn = document.getElementById('floating-button');
  if (!floatingBtn) return;

  function markFloatingButtonClosed() {
    const nowSeconds = Math.floor(Date.now() / 1000);

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { floating_button_closed_at: String(nowSeconds) }
      })
    })
    .then(response => {
      if (!response.ok) throw new Error('Network Error');
      return response.json();
    })
    .catch(err => {
      console.error('Floating Button Attribute Failed', err);
    });
  }

  // Clicking the link (or the close button, since it bubbles) marks it closed for 3 days
  floatingBtn.addEventListener('click', markFloatingButtonClosed);

  // Clicking the close button additionally removes it immediately (no navigation to wait for)
  const closeBtn = document.getElementById('floating-button-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      floatingBtn.remove();
    });
  }
});


/* -------------------------------------------------
  Scroll Zoom
------------------------------------------------- */
(function () {
  
  // Zoom <div> Variable
  const zoomEl = document.querySelector('[data-scroll-zoom]');
  if (!zoomEl) return;

  // Zoom Settings
  const maxZoom = parseFloat(zoomEl.dataset.maxZoom) || 1.5;
  const minZoom = 1;
  const el = zoomEl;
  el.style.willChange = 'transform';
  el.style.transformOrigin = 'center center';

  let ticking = false;

  function clamp01(v) { return Math.max(0, Math.min(1, v)); }

  function updateNow() {
    const rect = el.getBoundingClientRect();
    const progress = clamp01( -rect.top / rect.height );
    const scale = minZoom + (maxZoom - minZoom) * progress;
    el.style.transform = `scale(${scale})`;
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(updateNow);
    }
  }

  updateNow();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

})();


/* -------------------------------------------------
  Multi Level Menu Drawers
------------------------------------------------- */
(function () {
  if (window.__drawerDrilldownInit) return;
  window.__drawerDrilldownInit = true;

  // Get Root
  function getDrawerRoot(fromEl) {
    if (!fromEl || !(fromEl instanceof Element)) {
      return document.getElementById('menu-drawer');
    }
    return (
      fromEl.closest('#menu-drawer') ||
      fromEl.closest('.drawer') ||
      document.getElementById('menu-drawer')
    );
  }

  // Get Overlay
  function getOverlay(fromEl) {
    const root = getDrawerRoot(fromEl);
    return root ? root.querySelector('#drawer-drilldown-overlay') : null;
  }

  // Get Panel
  function getPanel(fromEl) {
    const root = getDrawerRoot(fromEl);
    return root ? root.querySelector('#drawer-panel') : null;
  }

  // Find Focus Element
  function getFirstFocusable(container) {
    if (!container) return null;
    return container.querySelector(
      'button, a, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
  }

  // Open Overlay
  function openOverlay(fromEl, templateId) {
    recalcDrawerSpacer();
    updateHeaderTransparency();
    const overlay = getOverlay(fromEl);
    const panel = getPanel(fromEl);
    const tpl = document.getElementById(templateId);
    if (!overlay || !panel || !tpl) return;
    overlay.innerHTML = '';
    overlay.appendChild(tpl.content.cloneNode(true));
    overlay.classList.remove('translate-x-full');
    overlay.classList.add('translate-x-0');
    overlay.setAttribute('aria-hidden', 'false');
    overlay.removeAttribute('inert');
    panel.classList.add('-translate-x-[100%]');
    overlay.setAttribute('tabindex', '-1');
    const focusTarget = getFirstFocusable(overlay) || overlay;
    try {
      focusTarget.focus({ preventScroll: true });
    } catch (e) {}
  }

  // Close Overlay
  function closeOverlay(fromEl) {
    const overlay = getOverlay(fromEl);
    const panel = getPanel(fromEl);

    if (!overlay || !panel) return;
    updateHeaderTransparency();

    // Move focus out before hiding (fixes aria-hidden warning)
    if (overlay.contains(document.activeElement)) {
      const focusTarget =
        getFirstFocusable(panel) || panel;
      try {
        focusTarget.focus({ preventScroll: true });
      } catch (e) {}
    }

    overlay.classList.remove('translate-x-0');
    overlay.classList.add('translate-x-full');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('inert', '');
    panel.classList.remove('-translate-x-[100%]');
    window.setTimeout(() => {
      overlay.innerHTML = '';
    }, 260);
  }

  // Click Handling
  document.addEventListener('click', function (e) {
    if (!(e.target instanceof Element)) return;

    const openBtn = e.target.closest('[data-drilldown-open]');
    if (openBtn) {
      e.preventDefault();
      openOverlay(openBtn, openBtn.getAttribute('data-drilldown-target'));
      return;
    }

    const backBtn = e.target.closest('[data-drilldown-back]');
    if (backBtn) {
      e.preventDefault();
      closeOverlay(backBtn);
      return;
    }

    const closeBtn = e.target.closest('[data-drawer-close]');
    if (closeBtn) {
      const overlay = getOverlay(closeBtn);
      if (overlay && overlay.getAttribute('aria-hidden') === 'false') {
        closeOverlay(closeBtn);
      }
    }
  });

  // Escape Handling
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;

    const openOverlayEl = document.querySelector(
      '#drawer-drilldown-overlay[aria-hidden="false"]'
    );

    if (!openOverlayEl) return;

    e.preventDefault();
    closeOverlay(openOverlayEl);
  });

})();


/* -------------------------------------------------
  Drawer Functions
------------------------------------------------- */
// Header transparent helpers
function updateHeaderTransparency() {
	const headerInner = document.querySelector('#header > div');
	if (!headerInner) return;

	// If Scroll > 100 - Never add transparency from this function
	if (window.scrollY > 100) {
		headerInner.classList.remove('bg-transparent');
		return;
	}

	const anyDrawerOpen = document.querySelector('.drawer.is-open');
	const drilldownOpen = document.querySelector('#drawer-drilldown-overlay[aria-hidden="false"]');

	// If any drawer or overlay is open → NEVER transparent
	if (anyDrawerOpen || drilldownOpen) {
		headerInner.classList.remove('bg-transparent');
		return;
	}

	// Only here can transparency be added
	if (window.scrollY < 50) {
		if (!headerInner.classList.contains("transparent-header")) return;
		headerInner.classList.add('bg-transparent');
	}
}

// Drawer Scroll Handler
(function() {
	let activeDrawer = null;
	let activeTrigger = null;
	let backdrop = null;
	const ACTIVE_TRIGGER_CLASS = 'is-active';

	// Remember scroll position so we can restore it after unlocking
	let scrollY = 0;

	function ensureBackdrop() {
		if (backdrop) return backdrop;
		backdrop = document.createElement('div');
		backdrop.className = 'drawer-backdrop';
		document.body.appendChild(backdrop);
		backdrop.addEventListener('mousedown', () => {
			if (activeDrawer) closeDrawer(activeDrawer);
		});

		// When backdrop finishes fading in
		backdrop.addEventListener('transitionend', (e) => {
			if (e.propertyName === 'opacity' && backdrop.classList.contains('is-visible')) {
				backdrop.classList.add('close-cursor');
			}
		});

		return backdrop;
	}

	function setExpanded(trigger, expanded) {
		if (!trigger) return;
		trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
	}

	function setTriggerActive(trigger, active) {
		if (!trigger) return;
		trigger.classList.toggle(ACTIVE_TRIGGER_CLASS, !!active);
	}

	// Focus Functions
	function getFocusable(container) {
		if (!container) return [];
		const selectors = [
			'a[href]',
			'button:not([disabled])',
			'input:not([type="hidden"]):not([disabled])',
			'select:not([disabled])',
			'textarea:not([disabled])',
			'[tabindex]:not([tabindex="-1"])',
			'[role="button"]',
		].join(',');
		return Array.from(container.querySelectorAll(selectors)).filter((el) => {
			const rect = el.getBoundingClientRect();
			return (rect.width > 0 || rect.height > 0) && getComputedStyle(el).visibility !== 'hidden';
		});
	}

	// Find Element
	function focusFirstInteractive(drawer) {
		const focusables = getFocusable(drawer);
		if (focusables.length) {
			focusables[0].focus({
				preventScroll: true
			});
			return;
		}
		drawer.focus?.({
			preventScroll: true
		});
	}

	// Lock Scroll
	function lockScroll() {
		scrollY = window.scrollY || window.pageYOffset || 0;
		document.body.style.top = `-${scrollY}px`;
		document.body.classList.add('overflow-hidden', 'fixed', 'w-full');
	}

	// Unlock Scroll
	function unlockScroll() {
		document.body.classList.remove('overflow-hidden', 'fixed', 'w-full');
		document.body.style.top = '';
		window.scrollTo(0, scrollY);
	}

	// Focus Search Input
	function focusSearchInput(drawer) {
		if (!drawer || drawer.id !== 'search-drawer') return;

		const input = drawer.querySelector('[data-predictive-search-input]');
		if (!input) return;

		// Delay slightly so CSS transition doesn't steal focus
		requestAnimationFrame(() => {
			input.focus({
				preventScroll: true
			});

			// Optional: select existing text
			if (input.value) {
				input.setSelectionRange(0, input.value.length);
			}
		});
	}

	// Open Drawer
  function openDrawer(drawer, trigger) {
	if (!drawer) return;

	recalcDrawerSpacer();

	// Close previous drawer first
	if (activeDrawer && activeDrawer !== drawer) {
		closeDrawer(activeDrawer, {
			restoreFocus: false
		});
	}

	// If there was a previous trigger, clear its active class
	if (activeTrigger && activeTrigger !== trigger) {
		setTriggerActive(activeTrigger, false);
	}

	activeDrawer = drawer;
	activeTrigger = trigger || null;

	// Mark trigger as active
	setTriggerActive(activeTrigger, true);

	// Toggle text if trigger has .icon-switch
  if (trigger && trigger.classList.contains('icon-switch')) {
    const icon = trigger.querySelector('.i-icon');

    if (icon) {
      // store original icon class
      if (!trigger.dataset.originalIcon) {
        const original = [...icon.classList].find(c => c.startsWith('i-') && c !== 'i-icon');
        trigger.dataset.originalIcon = original;
      }

      // remove existing icon class
      icon.classList.forEach(c => {
        if (c.startsWith('i-') && c !== 'i-icon') {
          icon.classList.remove(c);
        }
      });

      // add close icon
      icon.classList.add('i-close');
    }
  }

	// Remove inert so it can be focused / interacted with
	drawer.removeAttribute('inert');

	drawer.setAttribute('aria-hidden', 'false');
	drawer.classList.add('is-open');

	updateHeaderTransparency();

	const bg = ensureBackdrop();
	bg.classList.add('is-visible');

	setExpanded(activeTrigger, true);

	lockScroll();
	document.addEventListener('keydown', onKeyDown);

	let resizeRaf = null;

	function onResizeWhileDrawerOpen() {
		if (!activeDrawer) return;
		cancelAnimationFrame(resizeRaf);
		resizeRaf = requestAnimationFrame(recalcDrawerSpacer);
	}
	window.addEventListener('resize', onResizeWhileDrawerOpen, {
		passive: true
	});

	requestAnimationFrame(() => {
		// If search drawer, focus input
		focusSearchInput(drawer);

		// Otherwise focus first interactive element
		if (drawer.id !== 'search-drawer') {
			focusFirstInteractive(drawer);
		}
	});
}

	function clearDrawerInputs(drawer) {
		if (!drawer) return;

		// 1) Reset any forms (this will reset inputs, selects, radios, checkboxes inside the form)
		drawer.querySelectorAll('form').forEach(form => {
			try {
				form.reset();
			} catch (e) {
				/* ignore */
			}
		});

		// 2) Clear any inputs/selects/textarea that are NOT inside a form
		const controls = Array.from(drawer.querySelectorAll('input, textarea, select'));
		controls.forEach(el => {
			if (el.closest('form')) return; // already handled

			const type = (el.type || '').toLowerCase();

			if (type === 'checkbox' || type === 'radio') {
				el.checked = false;
			} else if (type === 'file') {
				// Clearing file input value — works in most browsers
				el.value = '';
				// If you used a custom file-preview node, also clear it here.
			} else if (el.tagName.toLowerCase() === 'select') {
				// Choose first option if exists, else deselect
				if (el.options && el.options.length) el.selectedIndex = 0;
				else el.value = '';
			} else {
				// text, email, number, password, textarea, etc.
				el.value = '';
			}
		});

		// 3) Clear contenteditable regions
		drawer.querySelectorAll('[contenteditable="true"]').forEach(node => {
			node.innerHTML = '';
		});
	}

	function closeDrawer(drawer, opts = {
		restoreFocus: true
	}) {
		if (!drawer) return;

		drawer.classList.remove('is-open');
		drawer.setAttribute('aria-hidden', 'true');
		updateHeaderTransparency();

		// Make it non-interactive / skipped in tab order when closed
		drawer.setAttribute('inert', '');

		if (backdrop) {
			backdrop.classList.remove('is-visible', 'close-cursor');
		}

    // Restore Button
    if (activeTrigger && activeTrigger.classList.contains('icon-switch')) {
      const icon = activeTrigger.querySelector('.i-icon');
      if (icon && activeTrigger.dataset.originalIcon) {
        icon.classList.remove('i-close');
        icon.classList.add(activeTrigger.dataset.originalIcon);
      }
    }

		// Clear trigger active state + aria-expanded
		setExpanded(activeTrigger, false);
		setTriggerActive(activeTrigger, false);

		document.removeEventListener('keydown', onKeyDown);

		unlockScroll();
		clearDrawerInputs(drawer);

		if (opts.restoreFocus && activeTrigger) {
			activeTrigger.focus({
				preventScroll: true
			});
		}

		activeDrawer = null;
		activeTrigger = null;
	}

	function onKeyDown(e) {
		if (!activeDrawer) return;
		if (e.key === 'Escape') {
			e.preventDefault();
			closeDrawer(activeDrawer);
		}
	}

	document.addEventListener('click', function(e) {
		const trigger = e.target.closest('[drawer-id]');
		if (trigger) {
			e.preventDefault();
			const id = trigger.getAttribute('drawer-id');
			const drawer = document.getElementById(id);

			if (!drawer) {
				console.warn('No drawer found with id:', id);
				return;
			}

			if (activeDrawer === drawer) {
				closeDrawer(drawer);
			} else {
				openDrawer(drawer, trigger);
			}
			return;
		}

		const closeBtn = e.target.closest('[data-drawer-close]');
		if (closeBtn) {
			const drawer = closeBtn.closest('.drawer');
			if (drawer) closeDrawer(drawer);
		}
	});
})();


/* -------------------------------------------------
  Marquee
------------------------------------------------- */
(function () {
  function initMarquees() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('[data-marquee]').forEach(function (root) {
      if (root.__marqueeInit) return;
      root.__marqueeInit = true;

      var track = root.querySelector('[data-marquee-track]');
      var content = root.querySelector('[data-marquee-content]');
      if (!track || !content) return;

      var SPEED = parseFloat(root.getAttribute('data-marquee-speed') || '100'); // px/sec
      var GAP = parseFloat(root.getAttribute('data-marquee-gap') || '32'); // px gap before each child

      var x = 0;
      var last = performance.now();
      var rafId = null;
      var resizeTimer = null;
      var stepWidth = 0;
      var lastViewportWidth = Math.round(window.innerWidth || document.documentElement.clientWidth || 0);

      track.style.willChange = 'transform';
      track.style.display = 'flex';
      track.style.alignItems = 'center';

      function cleanupClones() {
        var clones = track.querySelectorAll('[data-marquee-clone]');
        clones.forEach(function (c) {
          c.remove();
        });
      }

      function setInnerGapBeforeEach(node) {
        var children = Array.prototype.filter.call(node.children || [], function (ch) {
          return ch.nodeType === 1;
        });

        children.forEach(function (ch) {
          ch.style.marginLeft = GAP + 'px';
          ch.style.display = ch.style.display || 'inline-flex';
          ch.style.flexShrink = '0';
        });
      }

      function measureBaseWidth() {
        var prevDisplay = content.style.display;
        content.style.display = 'inline-flex';
        content.style.flexShrink = '0';

        setInnerGapBeforeEach(content);

        var w = content.getBoundingClientRect().width || 0;

        content.style.display = prevDisplay;
        return w;
      }

      function normalizeX() {
        if (!stepWidth || stepWidth < 1) return;
        x = x % stepWidth;
        if (x > 0) x -= stepWidth;
      }

      function buildClones(keepPosition) {
        var currentX = x;
        var currentStep = stepWidth;

        cleanupClones();

        // Do not hard reset the transform unless this is the first build.
        if (!keepPosition) {
          x = 0;
          track.style.transform = 'translate3d(0px, 0, 0)';
        }

        setInnerGapBeforeEach(content);

        stepWidth = measureBaseWidth();
        if (!stepWidth || stepWidth < 1) return;

        var viewport = Math.max(
          document.documentElement.clientWidth || 0,
          root.getBoundingClientRect().width || 0
        );

        var needed = Math.ceil((viewport * 2) / stepWidth);

        for (var i = 0; i < needed; i++) {
          var clone = content.cloneNode(true);
          clone.setAttribute('data-marquee-clone', '1');
          setInnerGapBeforeEach(clone);
          clone.style.display = 'inline-flex';
          clone.style.flexShrink = '0';
          track.appendChild(clone);
        }

        if (keepPosition && currentStep && stepWidth) {
          // Preserve visual progress across rebuilds.
          // Map the old offset into the new step width so it does not jump.
          var progress = Math.abs(currentX % currentStep) / currentStep;
          x = -(progress * stepWidth);
          normalizeX();
          track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
        } else {
          normalizeX();
        }
      }

      function tick(now) {
        var dt = (now - last) / 1000;
        last = now;

        x -= SPEED * dt;

        if (stepWidth > 0 && Math.abs(x) >= stepWidth) {
          x = x % stepWidth;
        }

        track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
        rafId = requestAnimationFrame(tick);
      }

      function start() {
        last = performance.now();
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(tick);
      }

      function onResize() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          var currentViewportWidth = Math.round(window.innerWidth || document.documentElement.clientWidth || 0);

          // Ignore height-only changes caused by mobile browser chrome.
          if (currentViewportWidth === lastViewportWidth) return;

          lastViewportWidth = currentViewportWidth;
          buildClones(true);
        }, 150);
      }

      function destroy() {
        if (rafId) cancelAnimationFrame(rafId);
        window.removeEventListener('resize', onResize);
        cleanupClones();
        root.__marqueeInit = false;
        root.__marqueeDestroy = null;
      }

      buildClones(false);
      start();

      window.addEventListener('resize', onResize, { passive: true });

      root.__marqueeDestroy = destroy;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMarquees);
  } else {
    initMarquees();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-marquee]').forEach(function (root) {
      if (root.__marqueeDestroy) root.__marqueeDestroy();
    });
    initMarquees();
  });
})();


/* -------------------------------------------------
  Menu Slider
------------------------------------------------- */
(function () {
  function initSwiper(el) {
    if (!el) return;

    if (el.__swiper) return;

    const scope = el.closest('[data-swiper-scope]') || el.parentElement || document;
    const loop = el.dataset.loop === 'true';
    const centered = el.dataset.centered === 'true';

    const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
    const p2 = 0.5 * rem;   // 0.5rem (p-2)
    const p3 = 0.75 * rem;  // 0.75rem (p-3)

    const slides = el.querySelectorAll('.swiper-slide');
    const slideCount = slides.length;
    const slidesPerView = slideCount <= 1 ? 1 : 1.1;

    el.__swiper = new Swiper(el, {
      slidesPerView: slidesPerView,
      spaceBetween: p3,
      slidesOffsetBefore: p3,
      slidesOffsetAfter: p3,

      breakpoints: {
        1024: {
          spaceBetween: p3,
          slidesOffsetBefore: p3,
          slidesOffsetAfter: p3
        }
      },

      grabCursor: true,
      slidesPerGroup: 1,
      loop,
      centeredSlides: centered,

      navigation: {
        nextEl: scope.querySelector('.menu-swiper-next'),
        prevEl: scope.querySelector('.menu-swiper-prev'),
      },

      pagination: {
        el: scope.querySelector('.menu-swiper-pagination'),
        clickable: true,
      },

      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },

      watchOverflow: true,
      observer: true,
      observeParents: true,
    });
  }

  function initAll() {
    document.querySelectorAll('.menu-swiper').forEach(initSwiper);
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor / dynamic section reload
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('.menu-swiper').forEach(initSwiper);
  });

  document.addEventListener('shopify:block:select', initAll);
  document.addEventListener('shopify:block:deselect', initAll);
})();


/* -------------------------------------------------
  Accessible Accordion Fix
------------------------------------------------- */
document.addEventListener('keydown', function (e) {
  if (
    e.target.matches('[data-dui-accordion-toggle]') &&
    (e.key === 'Enter' || e.key === ' ')
  ) {
    e.preventDefault();
    e.target.click();
  }
});


/* -------------------------------------------------
  Transparent Header Logic
------------------------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  const headerInner = document.querySelector("#header > div");
  if (!headerInner) return;

  if (!headerInner.classList.contains("transparent-header")) return;

  function updateHeader() {

    if (document.querySelector(".drawer-backdrop.is-visible")) {
      headerInner.classList.remove("bg-transparent");
      return;
    }

    if (window.scrollY <= 50) {
      headerInner.classList.add("bg-transparent");
    } else {
      headerInner.classList.remove("bg-transparent");
    }
  }

  // Run on load
  updateHeader();

  // Run on scroll
  window.addEventListener("scroll", updateHeader);
});


/* -------------------------------------------------
  Topbar Vertical Marquee
------------------------------------------------- */
function initVerticalScroller(container, options = {}) {
  if (!container) return;

  const config = {
    interval: options.interval ?? 3000,
    transitionTime: options.transitionTime ?? 500,
    pauseOnHover: options.pauseOnHover ?? true,
  };

  const list = container.querySelector('ul');
  if (!list) return;

  const originalItems = Array.from(list.children);
  if (originalItems.length === 0) return;

  container.style.overflow = 'hidden';
  container.style.position = container.style.position || 'relative';

  const wrapper = document.createElement('div');
  wrapper.style.display = 'block';
  wrapper.style.width = '100%';
  wrapper.style.willChange = 'transform';

  while (list.firstChild) {
    wrapper.appendChild(list.firstChild);
  }
  list.appendChild(wrapper);

  // Create empty placeholder
  const placeholder = document.createElement('li');
  placeholder.className = originalItems[0].className || '';
  wrapper.insertBefore(placeholder, wrapper.firstChild);

  let itemHeight = 0;
  let currentIndex = 0;
  let timerId = null;
  let isPaused = false;

  function recalcHeights() {
    const ref = wrapper.children[0];
    itemHeight = ref ? ref.offsetHeight : 0;
    container.style.height = itemHeight + 'px';
    wrapper.style.transform = `translateY(-${currentIndex * itemHeight}px)`;
  }

  function setTransition(enabled) {
    wrapper.style.transition = enabled
      ? `transform ${config.transitionTime}ms ease`
      : 'none';
  }

  function scrollNext() {
    if (isPaused) return;
    currentIndex++;
    setTransition(true);
    wrapper.style.transform = `translateY(-${currentIndex * itemHeight}px)`;

    const cloneIndex = wrapper.children.length - 1;

    if (currentIndex >= cloneIndex) {
      setTimeout(() => {
        setTransition(false);
        wrapper.style.transform = `translateY(-${1 * itemHeight}px)`;
        currentIndex = 1;
        wrapper.offsetHeight;
        setTransition(true);
      }, config.transitionTime + 10);
    }
  }

  function startTimer() {
    if (!timerId) {
      timerId = setInterval(scrollNext, config.interval);
    }
  }

  function stopTimer() {
    if (timerId) {
      clearInterval(timerId);
      timerId = null;
    }
  }

  function pause() {
    isPaused = true;
    stopTimer();
  }

  function resume() {
    isPaused = false;
    startTimer();
  }

  // Only add looping behavior if more than 1 real item
  const hasMultipleItems = originalItems.length > 1;

  if (hasMultipleItems) {
    const firstRealItem = wrapper.children[1];
    const clone = firstRealItem.cloneNode(true);
    wrapper.appendChild(clone);

    if (config.pauseOnHover) {
      container.addEventListener('mouseenter', pause);
      container.addEventListener('mouseleave', resume);
    }

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) pause();
      else resume();
    });
  }

  window.addEventListener('resize', () => {
    setTimeout(recalcHeights, 100);
  });

  setTimeout(() => {
    recalcHeights();

    setTransition(false);
    currentIndex = 0;
    wrapper.style.transform = `translateY(0px)`;

    wrapper.offsetHeight;

    setTimeout(() => {
      setTransition(true);
      wrapper.style.transform = `translateY(-${1 * itemHeight}px)`;
      currentIndex = 1;

      // 🔥 Only start rolling if multiple items
      if (hasMultipleItems) {
        setTimeout(() => {
          startTimer();
        }, config.transitionTime + 50);
      }

    }, 80);
  }, 20);

  return {
    destroy() {
      stopTimer();
    },
  };
}



/* -------------------------------------------------
  Product Card Image Rotation
------------------------------------------------- */
// initSpinSequences — minimal scroll-driven only
(function () {
  const DEFAULT_DIGITS = 5;
  const DEFAULT_EXT = 'webp';

  function padN(n, digits) { return String(n).padStart(digits, '0'); }
  function clamp01(n) { return Math.max(0, Math.min(1, n)); }
  function normalizeBaseFromFirst(firstFileUrl) {
    if (!firstFileUrl) return null;
    const noQuery = firstFileUrl.split('?')[0];
    const idx = noQuery.lastIndexOf('/');
    return idx >= 0 ? noQuery.slice(0, idx + 1) : noQuery;
  }

  function drawSingleFrame(ctx, canvas, img) {
    if (!img || !img.complete) return;
    const dpr = window.devicePixelRatio || 1;
    const cssW = Math.max(1, Math.round(canvas.clientWidth));
    const cssH = Math.max(1, Math.round(canvas.clientHeight));
    if (canvas.width !== cssW * dpr || canvas.height !== cssH * dpr) {
      canvas.width = cssW * dpr;
      canvas.height = cssH * dpr;
    }
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    const imgW = img.naturalWidth || img.width;
    const imgH = img.naturalHeight || img.height;
    if (!imgW || !imgH) return;

    const imgRatio = imgW / imgH;
    const canvasRatio = cssW / cssH;

    let drawW, drawH, offsetX, offsetY;
    if (imgRatio > canvasRatio) {
      drawH = cssH;
      drawW = drawH * imgRatio;
      offsetX = (cssW - drawW) / 2;
      offsetY = 0;
    } else {
      drawW = cssW;
      drawH = drawW / imgRatio;
      offsetX = 0;
      offsetY = (cssH - drawH) / 2;
    }

    ctx.clearRect(0, 0, cssW, cssH);
    ctx.drawImage(img, offsetX, offsetY, drawW, drawH);
  }

  // simple frames cache: key -> { frames, promise }
  const framesCache = new Map();
  function ensureFramesForPrefix(key, baseFolder, prefix, count, digits, ext) {
    if (framesCache.has(key)) return framesCache.get(key).promise;
    const frames = new Array(count);
    let loaded = 0, errored = 0;
    const promise = new Promise((resolve) => {
      for (let i = 0; i < count; i++) {
        const padded = padN(i + 1, digits);
        const url = baseFolder + prefix + padded + '.' + ext;
        const img = new Image();
        img.src = url;
        img.onload = function () {
          loaded++;
          if (loaded + errored === count) resolve(frames);
        };
        img.onerror = function () {
          errored++;
          console.warn('[spin] frame load error', url);
          if (loaded + errored === count) resolve(frames);
        };
        frames[i] = img;
      }
    });
    framesCache.set(key, { frames, promise });
    return promise;
  }

  // map element vertical position -> frame index
  function computeIndexFromViewportPosition(section, framesLen) {
    if (!section || framesLen <= 1) return 0;
    const rect = section.getBoundingClientRect();
    const viewportH = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

    // progress 0..1 as the section moves through the viewport
    // tweak formula to taste — this maps when rect.top==viewportH => 0, rect.bottom==0 => 1
    const factor = (viewportH - rect.top) / (viewportH + rect.height);
    const progress = clamp01(factor);
    const idx = Math.round(progress * (framesLen - 1));
    return Math.max(0, Math.min(framesLen - 1, idx));
  }

  function initSpinSequences(scope = document) {
    const sections = scope.querySelectorAll('.spin-sequence');
    if (!sections || !sections.length) return;

    sections.forEach((section) => {
      if (section.__spinInstanceInit) return;
      section.__spinInstanceInit = true;

      const canvas = section.querySelector('.spin-canvas');
      if (!canvas) {
        console.warn('[spin] missing .spin-canvas in .spin-sequence', section);
        return;
      }
      const ctx = canvas.getContext('2d');

      const digits = Number(section.dataset.digits) || DEFAULT_DIGITS;
      const ext = section.dataset.ext || DEFAULT_EXT;
      const rotatePrefix = section.getAttribute('data-rotate-prefix');
      const rotateCount = section.getAttribute('data-rotate-count') ? Number(section.getAttribute('data-rotate-count')) : null;
      const rawFirstFile = section.getAttribute('data-base');
      const baseFolder = normalizeBaseFromFirst(rawFirstFile);

      if (!rotatePrefix || !rotateCount || !baseFolder) {
        console.error('[spin] missing rotate-prefix / rotate-count / data-base for spin-sequence', section);
        return;
      }

      const cacheKey = `pref:${baseFolder}|${rotatePrefix}|${rotateCount}|${digits}|${ext}`;
      const framesPromise = ensureFramesForPrefix(cacheKey, baseFolder, rotatePrefix, rotateCount, digits, ext);

      let framesArr = null;
      let lastIndex = -1;

      // rAF-throttled scroll handler
      let ticking = false;
      function onScrollTick() {
        ticking = false;
        if (!framesArr || framesArr.length === 0) return;
        const idx = computeIndexFromViewportPosition(section, framesArr.length);
        if (idx !== lastIndex) {
          const img = framesArr[idx];
          if (img && img.complete) {
            drawSingleFrame(ctx, canvas, img);
            lastIndex = idx;
          }
        }
      }
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(onScrollTick);
      }

      // IntersectionObserver: attach scroll listener only when visible
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.target !== section) return;
          if (entry.isIntersecting) {
            // immediate draw + attach listeners
            onScroll();
            window.addEventListener('scroll', onScroll, { passive: true });
            window.addEventListener('resize', onScroll, { passive: true });
          } else {
            // detach listeners to save work
            window.removeEventListener('scroll', onScroll, { passive: true });
            window.removeEventListener('resize', onScroll, { passive: true });
          }
        });
      }, { root: null, rootMargin: '0px', threshold: [0, 0.01] });
      io.observe(section);

      // Responsive redraw when element resizes
      const ro = new ResizeObserver(() => {
        if (lastIndex >= 0 && framesArr && framesArr[lastIndex] && framesArr[lastIndex].complete) {
          drawSingleFrame(ctx, canvas, framesArr[lastIndex]);
        }
      });
      ro.observe(section);

      // load frames, draw first frame (or single frame) and wait for intersection to drive updates
      framesPromise.then(() => {
        const entry = framesCache.get(cacheKey);
        framesArr = entry ? entry.frames : [];
        if (!framesArr || framesArr.length === 0) {
          console.warn('[spin] frames array empty for', cacheKey);
          return;
        }

        // draw first available frame immediately
        const first = framesArr[0];
        if (first && first.complete) {
          drawSingleFrame(ctx, canvas, first);
          lastIndex = 0;
        } else if (first) {
          first.addEventListener('load', () => {
            drawSingleFrame(ctx, canvas, first);
            lastIndex = 0;
          });
        }
      }).catch((err) => {
        console.error('[spin] framesPromise rejected for', cacheKey, err);
      });

      // expose a cleanup handle
      section.__spinDestroy = function () {
        try {
          io.disconnect();
          ro.disconnect();
          window.removeEventListener('scroll', onScroll, { passive: true });
          window.removeEventListener('resize', onScroll, { passive: true });
        } catch (e) {}
      };
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initSpinSequences(document); });
  document.addEventListener('shopify:section:load', function (e) { initSpinSequences(e.target || document); });
})();


/* -------------------------------------------------
  Zoom Scroll
------------------------------------------------- */
(() => {
  const onReady = (fn) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  };

  onReady(() => {
    const els = Array.from(document.querySelectorAll('[data-scroll-zoom]'));
    if (els.length === 0) return;

    // Prepare per-element config
    const items = els.map(el => {
      const maxZoom = Math.max(1, parseFloat(el.dataset.maxZoom) || 1.5);
      const minZoom = Math.max(0, parseFloat(el.dataset.minZoom) || 1);
      el.style.willChange = 'transform';
      el.style.transformOrigin = 'center center';
      return { el, maxZoom, minZoom };
    });

    let ticking = false;

    function clamp01(v) { return Math.max(0, Math.min(1, v)); }

    function updateNow() {
      // Update all elements
      items.forEach(({ el, maxZoom, minZoom }) => {
        const rect = el.getBoundingClientRect();
        const progress = clamp01(-rect.top / rect.height);
        const scale = minZoom + (maxZoom - minZoom) * progress;
        el.style.transform = `scale(${scale})`;
      });
      ticking = false;
    }

    function onScrollOrResize() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updateNow);
      }
    }

    // Initial run
    updateNow();

    // Listen on window; passive for scroll
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });

  });
})();



/* -------------------------------------------------
  Open Cart Helper
------------------------------------------------- */
window.openDrawerById = function (id) {
  const btn = document.querySelector(`[drawer-id="${id}"]`);
  const drawer = document.getElementById(id);

  if (!btn || !drawer) return;
  if (drawer.classList.contains('is-open')) return;

  btn.click(); // triggers your existing drawer open handler
};

window.openCart = function () {
  window.openDrawerById('cart-drawer');
};


/* -------------------------------------------------
  Reset Cart Variables
------------------------------------------------- */
window.reset = function (btn) {
  // Fetch Cart
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      // Set Attribute
      attributes: { preloader: '0', promo_bar_closed: '0', floating_button_closed_at: '0' }
    })
  })
  .then(response => {
    if (!response.ok) throw new Error('Network Error');
    return response.json();
  })
  .catch(err => {
    console.error('Attribute Failed', err);
  });
};

document.addEventListener('keydown', function (e) {
  const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;

  const cmdOrCtrl = isMac ? e.metaKey : e.ctrlKey;

  if (cmdOrCtrl && e.key.toLowerCase() === 'k') {
    e.preventDefault();

    // Run your function, then reload so the promo bar reappears immediately (testing helper)
    window.reset(document.querySelector('[data-reset-btn]'))
      .then(() => window.location.reload());
  }
});


/* -------------------------------------------------
  Drawer Controller For Desktop Menu Item (replacement)
------------------------------------------------- */
(function () {
  // Find a UI toggle button that controls a drawer by id (tries a few common patterns)
  function findToggleForId(id) {
    if (!id) return null;
    const cleanId = String(id).replace(/^#/, '').trim();
    if (!cleanId) return null;

    // Prefer exact matches for attributes we use
    let btn = document.querySelector(`[aria-controls="${cleanId}"], [drawer-id="${cleanId}"]`);
    if (btn) return btn;

    // Common variations: data-toggle or button elements
    btn = document.querySelector(`button[aria-controls="${cleanId}"], [data-toggle][aria-controls="${cleanId}"], [data-drawer-target="${cleanId}"]`);
    if (btn) return btn;

    // Fallback: try to find a toggle that references the container id in other attributes
    btn = document.querySelector(`[aria-controls="#${cleanId}"], [drawer-id="#${cleanId}"]`);
    if (btn) return btn;

    return null;
  }

  // Disable transitions on a node (adds class no-transition then removes after TEMP_MS)
  const TEMP_MS = 300;
  const transitionTimers = new WeakMap();

  function addNoTransitionOnce(el) {
    if (!el) return;
    const prev = transitionTimers.get(el);
    if (prev) clearTimeout(prev);

    el.classList.add('no-transition');
    // force reflow
    void el.offsetHeight;

    const t = setTimeout(() => {
      try { el.classList.remove('no-transition'); } catch (e) {}
      transitionTimers.delete(el);
    }, TEMP_MS);

    transitionTimers.set(el, t);
  }

  function disableTransitionsForMenuDrawer() {
    // Only target the drilldown overlay and visible drawer containers.
    document.querySelectorAll('#drawer-drilldown-overlay').forEach(addNoTransitionOnce);
    document.querySelectorAll('.drawer').forEach(addNoTransitionOnce);
  }

  // Helper: returns true if controllerAttr contains the requested id (support comma/space and optional leading #)
  function controllerTargetsId(controllerAttr, id) {
    if (!controllerAttr || !id) return false;
    const parts = controllerAttr.split(/[\s,]+/).map(s => s.replace(/^#/, '').trim()).filter(Boolean);
    return parts.some(p => p === String(id));
  }

  // Click handler for elements that carry [drawer-controller]
  function handleControllerClick(ev) {
    const controller = ev.target instanceof Element ? ev.target.closest('[drawer-controller]') : null;
    if (!controller) return;

    // If this click is a synthetic one we created to re-run drilldown after opening drawer(s), skip handling.
    if (controller.__skipDrawerController) {
      try { delete controller.__skipDrawerController; } catch (e) {}
      return;
    }

    const raw = controller.getAttribute('drawer-controller') || '';
    const ids = raw.split(/[\s,]+/).map(s => s.trim()).filter(Boolean);
    if (!ids.length) return;

    // Normalize ids and look up drawer elements + toggle buttons
    const targets = ids.map((rawId) => {
      const clean = String(rawId).replace(/^#/, '').trim();
      const drawerEl = document.getElementById(clean);
      const toggle = findToggleForId(clean); // may be null
      const isOpen = drawerEl ? drawerEl.classList.contains('is-open') : false;
      return { id: clean, drawerEl, toggle, isOpen };
    });

    // RULE 1: If ALL targeted drawers exist and are already open -> do not intercept.
    const allOpen = targets.length > 0 && targets.every(t => t.drawerEl && t.isOpen);
    if (allOpen) {
      // Let native handlers run (drilldown opens, menu stays open)
      return;
    }

    // Otherwise we need to open any closed drawers first, then open drilldown.
    // Intercept the click.
    ev.preventDefault();

    // Temporarily disable transitions (existing helper)
    if (controllerTargetsId(raw, 'menu-drawer')) {
      disableTransitionsForMenuDrawer();
    }

    // Helper: attempt to open a single target (returns a Promise that resolves when open or timeout)
    function openTarget(t) {
      return new Promise((resolve) => {
        // If target is already open, resolve immediately
        if (t.drawerEl && t.drawerEl.classList.contains('is-open')) {
          resolve(true);
          return;
        }

        // If there is a toggle distinct from controller, click it to open
        if (t.toggle && t.toggle !== controller) {
          try {
            t.toggle.click();
          } catch (err) {
            const synthetic = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
            t.toggle.dispatchEvent(synthetic);
          }
        } else if (t.toggle && t.toggle === controller) {
          // If the controller itself is the toggle, let native click run by simulating it (but avoid recursion)
          try {
            controller.__skipDrawerController = true;
            const synthetic = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
            controller.dispatchEvent(synthetic);
          } catch (e) {
            try { controller.click(); } catch (e2) {}
          } finally {
            try { delete controller.__skipDrawerController; } catch (e) {}
          }
        } else {
          // No toggle found — try public API
          if (typeof window.openDrawerById === 'function') {
            try { window.openDrawerById(t.id); } catch (e) {}
          } else if (typeof window.openDrawer === 'function') {
            try { window.openDrawer(document.getElementById(t.id)); } catch (e) {}
          } else {
            // nothing to open; resolve (will probably cause drilldown to fail but avoid hanging)
            resolve(false);
            return;
          }
        }

        // Wait until the drawer element acquires the .is-open class or timeout
        const drawerToWatch = t.drawerEl || document.getElementById(t.id);
        const start = performance.now();
        const TIMEOUT = Math.max(300, TEMP_MS); // at least TEMP_MS (300ms)

        (function poll() {
          if (drawerToWatch && drawerToWatch.classList.contains('is-open')) {
            resolve(true);
            return;
          }
          if (performance.now() - start >= TIMEOUT) {
            // Timeout — resolve anyway
            resolve(false);
            return;
          }
          requestAnimationFrame(poll);
        })();
      });
    }

    // Open all targets that are not open (in parallel)
    const openPromises = targets.map(t => (t.isOpen ? Promise.resolve(true) : openTarget(t)));

    Promise.all(openPromises).then(() => {
      // Once drawers are opened (or timed out), dispatch a synthetic click on the controller to run drilldown logic.
      // Mark the controller so our handler ignores this synthetic click.
      controller.__skipDrawerController = true;

      // small micro-delay to let DOM/ARIA changes settle (animation may still be running but drilldown open handler
      // usually only needs the DOM to be present/interactive).
      const delay = 60;

      setTimeout(() => {
        try {
          const ev2 = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
          controller.dispatchEvent(ev2);
        } catch (e) {
          try { controller.click(); } catch (e2) {}
        } finally {
          // Ensure skip flag cleaned up in case handler didn't remove it
          try { delete controller.__skipDrawerController; } catch (e) {}
        }
      }, delay);
    }).catch(() => {
      // If something unexpected fails, still attempt to open drilldown once
      try {
        controller.__skipDrawerController = true;
        const ev2 = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
        controller.dispatchEvent(ev2);
      } catch (e) {
        try { controller.click(); } catch (e2) {}
      } finally {
        try { delete controller.__skipDrawerController; } catch (e) {}
      }
    });
  }

  // Wire delegated handler (non-passive so we can preventDefault)
  document.addEventListener('click', handleControllerClick, { passive: false });

  // Expose helpers for debugging/testing
  window.__drawerController = {
    findToggleForId,
    addNoTransitionOnce,
    disableTransitionsForMenuDrawer,
    TEMP_MS
  };
})();


/* -------------------------------------------------
  Product Tabs
------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.benefits-tabs').forEach((container) => {
    const buttons = container.querySelectorAll('.tab-btn');
    const contents = container.querySelectorAll('.tab-content');

    function activateTab(tab) {
      buttons.forEach((b) => {
        const isActive = b.getAttribute('data-tab') === tab;

        // Toggle background properly
        b.classList.toggle('bg-white', isActive);
        b.classList.toggle('bg-lightest', !isActive);

        b.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      contents.forEach((c) => c.classList.add('hidden'));

      const activeContent = container.querySelector(`[data-content="${tab}"]`);
      if (activeContent) {
        activeContent.classList.remove('hidden');
      }
    }

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        activateTab(btn.getAttribute('data-tab'));
      });
    });

    const firstTab = buttons[0]?.getAttribute('data-tab');
    if (firstTab) activateTab(firstTab);
  });
});